import { __awaiter, __generator } from "tslib";
import React, { useEffect } from 'react';
import { AppBar, Avatar, Toolbar, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import styleConstants from '../../../../constants/styles';
var useStyles = makeStyles(function (theme) {
    var _a;
    return createStyles({
        appbar: {
            backgroundColor: "#fff",
        },
        toolbar: (_a = {
                backgroundColor: "#fff",
                boxShadow: "0 0.5px 0 0 #ddd",
                paddingLeft: 15,
                paddingRight: 15
            },
            _a[theme.breakpoints.up('sm')] = {
                paddingLeft: 24,
                paddingRight: 24,
            },
            _a),
        icon: {
            position: "absolute",
            right: 0,
            color: styleConstants.color.icon,
            minWidth: 10,
        },
        text: {
            marginRight: 2,
            display: "flex",
            fontFamily: styleConstants.fontFamily.headerFontFamily,
            fontWeight: 100,
            color: styleConstants.color.headerFont,
            fontSize: styleConstants.fontSize.headerFontSize,
            textDecoration: "none",
            paddingLeft: 10,
            paddingRight: 10,
        },
        textInline: {
            marginRight: 4,
            display: "inline",
            fontFamily: styleConstants.fontFamily.headerFontFamily,
            fontWeight: 100,
            color: styleConstants.color.headerFont,
            fontSize: styleConstants.fontSize.headerFontSize,
            textDecoration: "none",
            paddingTop: "15px",
        },
        avatar: {
            width: 32,
            height: 32,
        },
    });
});
export var LinkinBioHeader = function (_a) {
    var metaData = _a.metaData;
    var styles = useStyles();
    if (!metaData)
        return React.createElement(React.Fragment, null);
    useEffect(function () {
        var faviconUpdate = function () { return __awaiter(void 0, void 0, void 0, function () {
            var favicon;
            return __generator(this, function (_a) {
                favicon = document.getElementById("favicon");
                if (favicon)
                    favicon.href = metaData.avatar;
                return [2];
            });
        }); };
        faviconUpdate();
    }, [metaData]);
    return (React.createElement(AppBar, { position: "static", elevation: 0, className: styles.appbar },
        React.createElement(Toolbar, { className: styles.toolbar },
            React.createElement("a", { href: metaData.link, target: "_blank" },
                React.createElement(Avatar, { alt: metaData.avatarAltText, src: metaData.avatar, className: styles.avatar })),
            React.createElement(Typography, { noWrap: true, component: "a", href: metaData.link, className: styles.text, target: "_blank" }, metaData.companyName)),
        React.createElement(Typography, { noWrap: true, align: "center", className: styles.textInline }, metaData.subHeading)));
};
